module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAWCAYAAAG6WPzXAAAAAXNSR0IArs4c6QAAAUVJREFUOBHtVL1Ow0AMtkPF1g50qgQVO6+A2GnfoWPFG7AxMMErwNaXYOfnEdhRicjUDu1czOdcfLm7RFWFOjAQqXX8fbbj++yECJc8d0Wtv1EgKxH7k9feJdBP82vLgL/gbvA79rAvWSHqd4jpPiVKXkEjMjxq5Ov87kZ7cieq8lnezw5pMf+AP+CLNVtdH4jW/PGNTK0Gx7KkEZW/v6CwURW/VjjjEZ+vnvSJLC/dOxK6Lp3m6QrqD09LTfTo/sga7a6cDviKNvL4FyXYn5g7VWrTx3RyFqvix2IMRI3HY0RscwzgJISi0UVEMMYQb5keFgAdGWHbrW8sfcsDkuulCSsR5ZTx1JbI8jtxDIq7LYvaTmPa/J3UbktMsf9CqSJNXzUqFJa33rhJb0eCnMJ9KZfzW3xPJkgbbE9tsAWWcUZHw5sfYsyBd0nnU9cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activeTasks/tasksActive.png
// module id = 927
// module chunks = 1